// src/components/StyledComponents.js
import styled from "styled-components";

// Botão principal
export const Button = styled.button`
  background: ${(props) =>
    props.variant === "primary" ? "#9e2480" : "#084d6e"};
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;

  &:hover {
    background: ${(props) =>
      props.variant === "primary" ? "#7a1d66" : "#063a52"};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 14px;
    min-width: 100px;
  }
`;

// Botão pequeno "Ok"
export const SmallOkButton = styled.button`
  background: #9e2480;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.3s ease;

  &:hover {
    background: #7a1d66;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// Container geral
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
`;

// Card da pesquisa
export const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  max-width: 700px;
  width: 100%;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
`;

// Input
export const Input = styled.input`
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  width: 100%;
  font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;

  &:focus {
    outline: none;
    border-color: #9e2480;
    box-shadow: 0 0 0 2px rgba(158, 36, 128, 0.2);
  }
`;

// Botões de opção
export const OptionButton = styled.button`
  background: ${(props) => (props.selected ? "#9e2480" : "#eee")};
  color: ${(props) => (props.selected ? "white" : "#333")};
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  border: none;
  margin: 6px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.45 : 1)};
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) =>
      props.disabled ? undefined : props.selected ? "#7a1d66" : "#ddd"};
  }
`;

// Texto genérico
export const Text = styled.p`
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
`;

// Navegação
export const NavigationButton = styled(Button)`
  min-width: 50px;
  padding: 10px;
  font-size: 18px;
`;

// Modal
export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; // <<< aqui é o importante
`;

export const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
  z-index: 10000; // opcional
`;

// Título
export const Title = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #084d6e;
`;

// Rodapé da marca
export const BrandFooterText = styled.p`
  margin-top: 20px;
  font-size: 14px;
  color: #999;
  text-align: center;
`;
